import { shadow } from 'styles/revampTokens';
import sizes from 'styles/theme/sizes';

import colors from '../../dataTheme';

// Typed without an explicit emotion CSSObject annotation so that it is
// assignable to Chakra UI's SystemStyleObject when used via the sx prop.
const datePickerStyle = {
  '& .react-datepicker-popper': {
    '& .react-datepicker': {
      width: sizes.full,
      boxShadow: shadow.overlay,
      border: `1px solid ${colors.border}`,
      minWidth: '137px',
      borderRadius: '8px',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      '& .react-datepicker__navigation': {
        top: sizes[2],

        '& .react-datepicker__navigation-icon:before': {
          borderColor: colors.textSecondary,
        },
      },
    },
    '.react-datepicker__triangle': {
      transform: 'none !important',
    },
    '& .react-datepicker__triangle::after': {
      left: '30px !important',
    },
    '& .react-datepicker__triangle::before': {
      left: '30px !important',
    },
  },

  '& .react-datepicker__header': {
    backgroundColor: colors.surface,
    borderBottom: `1px solid ${colors.border}`,
    color: colors.textDark,
  },

  '& .react-datepicker__month-container': {
    width: sizes.full,

    '& .react-datepicker__month-wrapper': {
      display: 'flex',
      justifyContent: 'space-around',

      div: {
        padding: `${sizes[2]} ${sizes[4]}`,
        borderRadius: sizes[2],
        color: colors.textDark,
        fontWeight: 'normal',
        backgroundColor: 'transparent',
      },
    },

    '& .react-datepicker__month-wrapper div[aria-selected="true"]': {
      background: colors.activeBg,
      color: colors.primary,
    },
  },

  '& .react-datepicker__year': {
    '& .react-datepicker__year-wrapper': {
      div: {
        width: '100%',
      },
    },
  },
};

export default datePickerStyle;
